import React from 'react'
import OnVisibile from 'react-on-visible'
import respect from '../../../images/careers/Respect_Integrity.svg'
import teamwork from '../../../images/about-us/Teamwork.svg'
import grow from '../../../images/about-us/Grow.svg'
import notLife from '../../../images/careers/Work_is_not_life.svg'
import './styles.scss'

const TabsCareers = props => {
  const cultureCards = [
    {
      img: respect,
      alt: 'Respect and integrity for our team, customers and community.',
      text: 'Respect and integrity for our team, customers and community.',
    },
    {
      img: grow,
      alt: "We're building a place where you can learn and grow.",
      text: "We're building a place where you can learn and grow.",
    },
    {
      img: teamwork,
      alt: 'We believe in teams, not fiefdoms. Leaders, not tyrants.',
      text: 'We believe in teams, not fiefdoms. Leaders, not tyrants.',
    },
    {
      img: notLife,
      alt: 'Work is not life',
      text: 'Work is not life',
    },
  ]

  return (
    <section className="section tab-careers bg-gradient">
      <div className="container content">
        <div className="section-title">
          <h2 className="title">Our Culture & Values</h2>
          <p className="subtitle">
            Creating a space where everyone can thrive.
          </p>
        </div>
        <div className="tab-careers-grid">
          {cultureCards.map(card => (
            <OnVisibile key={card.text} className="tab-careers-grid-item">
              <img className="icon" src={card.img} alt={card.text} />
              <p>{card.text}</p>
            </OnVisibile>
          ))}
        </div>
      </div>
    </section>
  )
}

export default TabsCareers
